<template>
	<p id="noPlansBlock" class="alert alert-info text-center">Sorry, there are no plans available in your area.</p>
</template>
